"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFulfillerMethodMigrated = exports.isMethodMigrated = exports.getMigrationData = exports.setTransmissionMethodsMigrationData = exports.setFulfillerMethodMigration = exports.getFulfillerMethodMigration = exports.setFulfillerMigrationData = exports.getFulfillerMigrationData = void 0;
const cimpress_tagliatelle_1 = __importDefault(require("cimpress-tagliatelle"));
const shared_1 = require("../models/shared");
const MigrationTag = {
    [shared_1.Env.PRODUCTION]: 'urn:supplierIntegrations:migration',
    [shared_1.Env.INTEGRATION]: 'urn:supplierIntegrations:migration:integration',
    [shared_1.Env.DEVELOPMENT]: 'urn:supplierIntegrations:migration:integration'
};
const TransmissionMethodsUri = {
    [shared_1.Env.PRODUCTION]: 'https://api.supplierintegrations.cimpress.io/v0/transmissionMethods',
    [shared_1.Env.INTEGRATION]: 'https://int-api.supplierintegrations.cimpress.io/v0/transmissionMethods',
    [shared_1.Env.DEVELOPMENT]: 'https://int-api.supplierintegrations.cimpress.io/v0/transmissionMethods',
};
const options = {
    timeout: 5000,
    retryAttempts: 3,
    retryDelayInMs: 1000,
    errorFunction: () => {
        // do nothing.
    },
    debugFunction: () => {
        // do nothing.
    }
};
const tagliatelle = new cimpress_tagliatelle_1.default(options);
const getFulfillerMigrationData = async (accessToken, fulfillerUrl, env = shared_1.Env.PRODUCTION) => {
    try {
        const migrationTag = await tagliatelle
            .getTagByResourceAndKey(accessToken, fulfillerUrl, MigrationTag[env]);
        const data = JSON.parse(migrationTag.value);
        return data;
    }
    catch (error) {
        if (error.constructor.name === 'TagNotFound') {
            return null;
        }
        console.error(`Failure to fetch tag for the given fulfillerUrl`, { resourceUri: fulfillerUrl, error });
        throw error;
    }
};
exports.getFulfillerMigrationData = getFulfillerMigrationData;
const setFulfillerMigrationData = async (accessToken, fulfillerUrl, data, env = shared_1.Env.PRODUCTION) => {
    await tagliatelle.createOrUpdateTag(accessToken, fulfillerUrl, MigrationTag[env], JSON.stringify(data));
};
exports.setFulfillerMigrationData = setFulfillerMigrationData;
const getFulfillerMethodMigration = async (accessToken, fulfillerUrl, method, env = shared_1.Env.PRODUCTION) => {
    var _a;
    const tag = await (0, exports.getFulfillerMigrationData)(accessToken, fulfillerUrl, env);
    if (tag) {
        return (_a = tag[method]) !== null && _a !== void 0 ? _a : null;
    }
    return null;
};
exports.getFulfillerMethodMigration = getFulfillerMethodMigration;
const setFulfillerMethodMigration = async (accessToken, fulfillerUrl, method, integrationConfigurationUrl, data, env = shared_1.Env.PRODUCTION) => {
    let newData = {};
    const existingData = await (0, exports.getFulfillerMigrationData)(accessToken, fulfillerUrl, env);
    if (existingData) {
        newData = Object.assign({}, existingData);
    }
    newData[method] = data;
    newData.integrationConfigurationUrl = integrationConfigurationUrl;
    await tagliatelle.createOrUpdateTag(accessToken, fulfillerUrl, MigrationTag[env], JSON.stringify(newData));
};
exports.setFulfillerMethodMigration = setFulfillerMethodMigration;
const setTransmissionMethodsMigrationData = async (accessToken, data, env = shared_1.Env.PRODUCTION) => {
    await tagliatelle.createOrUpdateTag(accessToken, TransmissionMethodsUri[env], MigrationTag[env], JSON.stringify(data));
};
exports.setTransmissionMethodsMigrationData = setTransmissionMethodsMigrationData;
const getMigrationData = async (accessToken, fulfillerUrl, env = shared_1.Env.PRODUCTION) => {
    var _a, _b;
    const transmissionMethodsUrl = TransmissionMethodsUri[env];
    try {
        const tags = await tagliatelle
            .getTags(accessToken, {
            resourceUri: [fulfillerUrl, transmissionMethodsUrl],
            key: MigrationTag[env]
        });
        const fulfillerMigrationStringifiedData = (_a = tags.results.find((tag) => tag.resourceUri === fulfillerUrl)) === null || _a === void 0 ? void 0 : _a.value;
        const transmissionMethodsMigrationStringifiedData = (_b = tags.results.find((tag) => tag.resourceUri === transmissionMethodsUrl)) === null || _b === void 0 ? void 0 : _b.value;
        return {
            fulfillerMigrationData: fulfillerMigrationStringifiedData && JSON.parse(fulfillerMigrationStringifiedData),
            transmissionMethodsMigrationData: transmissionMethodsMigrationStringifiedData && JSON.parse(transmissionMethodsMigrationStringifiedData)
        };
    }
    catch (error) {
        console.error(`Failure to fetch tag for the given urls`, { resourceUri: [fulfillerUrl, transmissionMethodsUrl], error });
        throw error;
    }
};
exports.getMigrationData = getMigrationData;
const isMethodMigrated = (migrationData, transmissionMethod) => {
    var _a, _b;
    const { fulfillerMigrationData, transmissionMethodsMigrationData } = migrationData;
    const fulfillerFlag = (_a = fulfillerMigrationData === null || fulfillerMigrationData === void 0 ? void 0 : fulfillerMigrationData[transmissionMethod]) === null || _a === void 0 ? void 0 : _a.migrated;
    const globalFlag = transmissionMethodsMigrationData === null || transmissionMethodsMigrationData === void 0 ? void 0 : transmissionMethodsMigrationData[transmissionMethod];
    return (_b = fulfillerFlag !== null && fulfillerFlag !== void 0 ? fulfillerFlag : globalFlag) !== null && _b !== void 0 ? _b : false;
};
exports.isMethodMigrated = isMethodMigrated;
const isFulfillerMethodMigrated = async (accessToken, fulfillerUrl, transmissionMethod, env = shared_1.Env.PRODUCTION) => {
    const migrationData = await (0, exports.getMigrationData)(accessToken, fulfillerUrl, env);
    return (0, exports.isMethodMigrated)(migrationData, transmissionMethod);
};
exports.isFulfillerMethodMigrated = isFulfillerMethodMigrated;
